import { useId } from "react";
import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import { AmountStepperField } from "web_myplann/Shared/Components/AmountStepperField";
import { StackedField } from "web_myplann/Shared/Components/StackedField";

type Props<
	FormType extends FieldValues,
	TName,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	label: string;
	hint?: string;
};

export const FormAmountStepperField = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	label,
	hint,
}: Props<FormType, TName, TContext, TTransformed>) => {
	const inputId = useId();

	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
				<StackedField
					label={label}
					htmlFor={inputId}
					hint={hint}
					error={error?.message}
				>
					<AmountStepperField
						inputId={inputId}
						focusRef={ref}
						value={value ?? 0}
						onChange={onChange}
						error={!!error}
					/>
				</StackedField>
			)}
		/>
	);
};
